module.exports = __webpack_public_path__ + "static/img/camerafor2.864e4dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/camerafor2.png
// module id = 7J7n
// module chunks = 24